/*
 * @Author: Eugene
 * @Date: 2021-05-07 12:27:40
 * @Last Modified by: Eugene
 * @Last Modified time: 2021-05-08 14:37:34
 */

import { message } from 'antd';
import {
  getLiveChannelList,
  getLiveScreenRatio,
  addLiveChannel,
  deleteLiveChannel,
  editLiveChannel,
} from '@/services/live/channel';

export default {
  namespace: 'liveChannelState',

  state: {
    dataSource: [],
    pagination: {
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total) => `共 ${total} 条`,
    },
    screenRatioList: [],
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const res = yield call(getLiveChannelList, payload);
      if (res.result.code === '00000') {
        yield put({
          type: 'fetchSuccess',
          payload: {
            dataSource: res.result.data,
            pagination: {
              current: res.result.page.currentPage,
              pageSize: res.result.page.pageSize,
              total: res.result.page.count,
            },
          },
        });
      } else {
        message.error('获取渠道列表失败！', 3);
      }
    },
    *fetchScreenRatio({ payload }, { call, put, select }) {
      const { screenRatioList } = yield select(
        (state) => state.liveChannelState,
      );
      // 判断比例列表是否请求过
      if (screenRatioList.length) return;
      const res = yield call(getLiveScreenRatio, {});
      if (res.result.code === '00000') {
        yield put({
          type: 'fetchScreenRatioOk',
          payload: {
            screenRatioList: res.result.data,
          },
        });
      } else {
        message.error(res.result.msg, 3);
      }
    },
    *addLiveChannel({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(addLiveChannel, { requestData });
      if (res.result.code === '00000') {
        message.success('新增渠道成功', 3);
        resolve(res);
      } else {
        message.error(`新增渠道失败：${res.result.msg}`, 3);
      }
    },
    *editLiveChannel({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(editLiveChannel, { requestData });
      if (res.result.code === '00000') {
        message.success('更新渠道成功', 3);
        resolve(res);
      } else {
        message.error(`更新渠道失败：${res.result.msg}`, 3);
      }
    },
    *deleteLiveChannel({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(deleteLiveChannel, { requestData });
      if (res.result.code === '00000') {
        message.success('删除渠道成功', 3);
        resolve(res);
      } else {
        message.error(`删除渠道失败：${res.result.msg}`, 3);
      }
    },
    *changeLiveChannelStatus({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(editLiveChannel, { requestData });
      if (res.result.code === '00000') {
        message.success(`${requestData.status === 1 ? '禁用' : '启用'}成功`, 3);
        resolve(res);
      } else {
        message.error(
          `${requestData.status === 1 ? '禁用' : '启用'}失败：${
            res.result.msg
          }`,
          3,
        );
      }
    },
  },

  reducers: {
    fetchSuccess(state, action) {
      const { dataSource, pagination } = action.payload;
      return {
        ...state,
        dataSource,
        pagination: {
          ...state.pagination,
          ...pagination,
        },
      };
    },
    fetchScreenRatioOk(state, action) {
      const { screenRatioList } = action.payload;
      return {
        ...state,
        screenRatioList,
      };
    },
  },
};
